import { KlevuEvents } from "../../events/KlevuEvents.js";
import { extractActiveFilters } from "../../utils/extractActiveFilters.js";
/**
 * Automatically injects events helpers to klevuFetch result object.
 *
 * @ignore
 * @category KlevuEvents
 * @param result
 * @param func
 * @returns
 */
export function FetchResultEvents(result, func) {
    var _a;
    switch (func.klevuFunctionId) {
        case "search": {
            return {
                getSearchClickSendEvent: () => {
                    let viewSent = false;
                    return (productId, variantId, override) => {
                        var _a;
                        if (!viewSent) {
                            KlevuEvents.search({
                                term: result.meta.searchedTerm,
                                totalResults: result.meta.noOfResults,
                                typeOfSearch: result.meta.typeOfSearch,
                                activeFilters: extractActiveFilters(result),
                                override,
                            });
                            viewSent = true;
                        }
                        const record = [
                            ...result.records,
                            ...((_a = func.previousResultRecords) !== null && _a !== void 0 ? _a : []),
                        ].find((r) => r.id === productId);
                        if (!record) {
                            throw new Error(`KlevuEvents: Given "${productId}" doesn't exists in results`);
                        }
                        KlevuEvents.searchProductClick({
                            product: record,
                            searchTerm: result.meta.searchedTerm,
                            variantId,
                        });
                    };
                },
            };
        }
        case "categoryMerchandising": {
            return {
                getCategoryMerchandisingClickSendEvent: () => {
                    return (productId, categoryTitle, variantId, override) => {
                        var _a, _b, _c, _d, _e;
                        const record = [
                            ...result.records,
                            ...((_a = func.previousResultRecords) !== null && _a !== void 0 ? _a : []),
                        ].find((r) => r.id === productId);
                        if (!record) {
                            throw new Error(`KlevuEvents: Given "${productId}" doesn't exists in results`);
                        }
                        const index = result.records.findIndex((r) => r.id === productId);
                        const q = (_b = func.queries) === null || _b === void 0 ? void 0 : _b.find((q) => { var _a, _b; return Boolean((_b = (_a = q.settings) === null || _a === void 0 ? void 0 : _a.query) === null || _b === void 0 ? void 0 : _b.categoryPath); });
                        let abTestId, abTestVariantId;
                        if (!func.params) {
                            func.params = {};
                        }
                        if (func.params.abtest) {
                            abTestId = func.params.abtest.abTestId;
                            abTestVariantId = func.params.abtest.abTestVariantId;
                        }
                        KlevuEvents.categoryMerchandisingProductClick(record, categoryTitle, (_e = (_d = (_c = q === null || q === void 0 ? void 0 : q.settings) === null || _c === void 0 ? void 0 : _c.query) === null || _d === void 0 ? void 0 : _d.categoryPath) !== null && _e !== void 0 ? _e : "unknown", variantId, index + 1, abTestId, abTestVariantId, extractActiveFilters(result), override);
                    };
                },
            };
        }
        case "kmcRecommendation": {
            const config = (_a = func.params) === null || _a === void 0 ? void 0 : _a.kmcConfig;
            return {
                getRecommendationClickSendEvent: () => {
                    return (productId, variantId, override) => {
                        var _a;
                        const record = [
                            ...result.records,
                            ...((_a = func.previousResultRecords) !== null && _a !== void 0 ? _a : []),
                        ].find((r) => r.id === productId);
                        if (!record) {
                            throw new Error(`KlevuEvents: Given "${productId}" doesn't exists in results`);
                        }
                        if (!config) {
                            throw new Error("KlevuEvents: Recommendation kmcConfig not available");
                        }
                        const index = result.records.findIndex((r) => r.id === productId);
                        KlevuEvents.recommendationClick({
                            recommendationMetadata: config.metadata,
                            product: record,
                            productIndexInList: index + 1,
                            variantId,
                            override,
                        });
                    };
                },
            };
        }
        default:
            return {};
    }
}
